import { helper } from './helper'

export const errorMessage = {
  mixins: [helper],
  methods: {
    showErrorMessage (config) {
      if(this.showSpinner) this.showSpinner = false
      if(this.disabled) this.disabled = false
      if(this.disable) this.disable = false
      this.show_toast(
        config.type || 'error',
        config.title || 'Erro',
        config.err.response.data.originalMessage,
        config.timeout || 6000
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/error-message.js